import Icon from '../components/Icon.vue'

Icon.register({
  'pause-circle': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM240 336v-160c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16v160c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16zM352 336v-160c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16v160c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/pause-circle.js
// module id = 1616
// module chunks = 0